import React from 'react';
import moment from "moment";
import Link from '../base/Link';
import API from "../base/API";
import Auth from "../auth/Auth";
import Storage from "../base/Storage";
import SorTable from "../base/SorTable";
import DeleteButton from "../base/DeleteButton";
import { translate } from '../base/Translation';

export default class BranchList extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_branches: "/branch/fetch/all?limit_from=:from&limit_max=:to&brand=:brand",
			delete_branch: "/branch/delete/:branch"
		});

		this.state = {
			limit_from: 0,
			limit_to: 99999,
			branches: [],
			tableData: [],
			tableColumns: [
				{ name: "identifier", display: translate("Kód"), sort: true, width: 12 },
				{ name: "name", display: translate("Názov"), sort: true, width: 24 },
				{ name: "address", display: translate("Adresa, obec"), sort: true, width: 23 },
				{ name: "brands", display: translate("Značka"), sort: true, width: 19 },
				{ name: "date_created", display: translate("Vytvorené"), sort: true, width: 9 },
				{ name: "date_updated", display: translate("Upravené"), sort: true, width: 9 },
				{ name: "options", display: " ", width: 4 }
			]
		};
	}

	convertDataForTable(data) {
		return data.map(function (branch) {
			let data = {};
			data.id = branch.id;
			data.identifier = branch.identifier;
			data.address = branch.address + ", " + branch.city;
			data.name = <Link to={"/branches/edit/" + branch.id} textIfNoAccess={true} permission="BranchEdit">{branch.name}</Link>;
			data.brands = branch.brand.name;
			data.date_created = moment(branch.created.date).format("D.M.Y");
			data.date_updated = moment(branch.updated.date).format("D.M.Y");
			data.options = (
				<div style={{ textAlign: "right" }}>
					<DeleteButton onClick={this.deleteBranch.bind({ branch: branch.id, currentComponent: this })} permission="BranchNew" />
				</div>
			);
			return data;
		}.bind(this));
	}

	fetchData() {
		let brandFilter = Storage.get("brand_filter");

		this.api.request({
			cache: true,
			route: "get_branches",
			params: { from: this.state.limit_from, to: this.state.limit_to, brand: (brandFilter ? brandFilter.id : "all") },
			success: (response) => {
				let tableData = this.convertDataForTable(response);
				this.setState({ branches: response, tableData });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	deleteBranch(evt) {
		this.currentComponent.api.request({
			route: "delete_branch",
			params: { branch: this.branch },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	render() {
		return (
			<SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="name" title={translate("Prevádzky")} right={() => {
				if (Storage.get("allowed_components").indexOf("BranchNew") === -1) {
					return "";
				}
				return (
					<Link to="/branches/add/new" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
				)
			}} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/branch/BranchList.js